import { operatorsTracking } from "./operatorsConfig"

type TrackParams = Record<string, any>

const firedEvents = new Set<string>()

declare global {
    interface Window {
        dataLayer?: any[]
        gtag?: (...args: any[]) => void
        fbq?: (...args: any[]) => void
    }
}

export const trackTicketOpen = (ticketType: string) => {
    trackEvent("ticket_open", {
        ticket_type: ticketType
    })

    if (window.gtag) {
        window.gtag("event", "page_view", {
            page_title: ticketType,
            ticket_type: ticketType
        })
    }
    if (window.fbq) {
        window.fbq('track', 'PageView', {
            content_name: ticketType
        })
    }
}

export const initTracking = (operator: string) => {
    const config = operatorsTracking[operator]
    if (config?.googleTag) {
        const script = document.createElement("script")
        script.src = `https://www.googletagmanager.com/gtag/js?id=${config.googleTag}`
        script.async = true
        document.head.appendChild(script)

        window.dataLayer = window.dataLayer || []
        window.gtag = function() {
            window.dataLayer!.push(arguments)
        }

        window.gtag('js', new Date())

        window.gtag('config', config.googleTag, {
            send_page_view: false
        })
    }

    if (config?.facebookPixel) {
        const script = document.createElement("script")
        script.src = "https://connect.facebook.net/en_US/fbevents.js"
        script.async = true
        document.head.appendChild(script)

        window.fbq = window.fbq || function() {
            (window.fbq as any).callMethod
                ? (window.fbq as any).callMethod.apply(window.fbq, arguments)
                : (window.fbq as any).queue.push(arguments)
        }

        window.fbq('init', config.facebookPixel)
    }
}

export const trackEvent = (
    eventName: string,
    params?: TrackParams,
    options?: { once?: boolean }
) => {
    if (options?.once && firedEvents.has(eventName)) {
        return
    }

    if (options?.once) {
        firedEvents.add(eventName)
    }

    if (window.gtag) {
        window.gtag("event", eventName, params)
    }

    if (window.fbq) {
        window.fbq("trackCustom", eventName, params)
    }
}